import {
    Box
} from '@theme-ui/components';
import { DashboardNotice } from '~/Common';

export const PageHeader = ({ children, sx, ...props }) => {
    return (
        <>
            <DashboardNotice sx={{ position: 'relative', zIndex: 1 }} />
            <Box sx={{ ...sx }} {...props}>
                {children}
            </Box>
        </>
    );
};
